import GeneralService from "./GeneralService";
import { ApiKeyOrGetter } from "./GeneralService";
import { Component } from "react";

export class ConfigService extends Component {
  public static getModels(
    intentGroupId: number,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.get(
      `/config/models/full-with-prompts/${intentGroupId}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getEndpoints(loadingHandler: any, apiKey: ApiKeyOrGetter) {
    return GeneralService.get(
      "/config/endpoints",
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getAgents(loadingHandler: any, apiKey: ApiKeyOrGetter) {
    return GeneralService.get(
      "/agent/agents",
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getAgentsWithReleases(
    loadingHandler: any,
    apiKey: ApiKeyOrGetter,
    includeSubagents: boolean = true
  ) {
    return GeneralService.get(
      `/agent/agents/releases?include_subagents=${includeSubagents}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
}
